import React, { PureComponent, Fragment } from 'react';
import './HeaderMenu.module.css';
import { Link } from 'formlabs-web-components/Link';
import MenuSignIn from './MenuSignIn';
import StoreButton from '../storefront/MenuButton';

const MenuItem = ({
  hoverOptions,
  itemIndex,
  dropdownOpen,
  menuItem,
  handleHoverMenu,
  itemType,
  storePage,
  typeColor
}) => {
  return (
    <div
      styleName={`${
        hoverOptions === itemIndex && dropdownOpen ? 'has-dropdown' : ''
      } main-menu-item`}
      key={`main-menu-div-${itemIndex}`}
    >
      {itemType == 'left' && (
        <Link
          to={menuItem.url}
          styleName="top-level-menu"
          openInNewWindow={menuItem.newWindow}
          onMouseEnter={() => handleHoverMenu(itemIndex)}
        >
          {menuItem.name}
        </Link>
      )}
      {itemType == 'right' && (
        <Link
          to={menuItem.url}
          styleName="top-level-menu"
          key={`${menuItem.url} ${menuItem.name}`}
        >
          {menuItem.name}
        </Link>
      )}
      {itemType == 'MenuSignIn' && (
        <MenuSignIn typeColor={dropdownOpen ? 'black' : typeColor} />
      )}
      {itemType == 'StoreButton' && storePage && <StoreButton />}
    </div>
  );
};

export default MenuItem;
